<template>
  <div>
    <CContainer>
      <CRow class="justify-content-center mt-4">
        <CCol md="12 text-center">
          <h1 class="mb-4">{{ $t("admin_guide.page_title") }}</h1>
          <div v-if="trainings && trainings.guide">
            <iframe
              :src="trainings.guide[user.role.name]"
              class="trainings-iframe"
            />
          </div>
          <div v-else>{{ $t("admin_guide.no_tutorials") }}</div>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import { mapGetters } from "vuex"

export default {
  name: "AdminGuide",
  components: {},
  created() {
    this.$store.dispatch("updates/getTrainings")
  },
  computed: {
    ...mapGetters({
      trainings: "updates/trainings",
      user: "authentication/user"
    })
  }
}
</script>
